export default __webpack_public_path__ + "static/media/480_dummy2016-modelportfolio01-de.886017c8.png";